export const DOCUMENT_TYPES = [
	{ value: "01", label: "Factura" },
  	{ value: "91", label: "Nota Credito Factura" },
	{ value: "92", label: "Nota Debito Factura" },
  	{ value: "20", label: "Equivalente POS" },
	{ value: "94", label: "Nota Ajuste Equivalente" },
  	{ value: "05", label: "Documento Soporte" },
	{ value: "95", label: "Nota Ajuste Soporte" }
];